import {http} from '../utils'

const saveApi = params => {
  const url = '/market/config/storage/save'
  return http.post(url, params)
}

export default {
  saveApi,
}
